import React from "react";
import { Form, Input } from "antd";

const formIteam = [
	{
		name: "ventas",
		title: "Ventas",
		description: "Comentarios de retroalimentación a Comercial para mejorar alguna parte del flujo o mejorar ventas futuras.",
	},
	{
		name: "marketing",
		title: "Marketing",
		description: "Link al proyecto final (drive a ejecutable / producción / link )",
	},
];

export const FormIteamCommercial = ({ disabled = false }) => {
	return (
		<>
			{formIteam.map((formI, index) => (
				<div key={`${index}-operation`} className="w-full  flex flex-col gap-2">
					<p className="text-[12px] font-bold">{formI.title}</p>
					<p className="text-[10px] text-[#9A9A9A]">{formI.description}</p>
					<Form.Item
						name={["comercial", formI.name]}
						rules={[
							{
								required: true,
								message: "No puede ir vacio",
							},
						]}
					>
						<Input.TextArea
							placeholder="Comentario"
							autoSize={{
								minRows: 5,
								maxRows: 5,
							}}
							disabled={disabled}
						/>
					</Form.Item>
				</div>
			))}
		</>
	);
};
